import * as React from "react";

const IconHeaderLocationInactive: React.FC = () => {
    return (
        <svg width="24" height="24" fill="currentColor" viewBox="0 0 11 15">
            <path
                fill="currentColor"
                d="M7.438 6.014A2.19 2.19 0 0 1 5.25 8.207a2.19 2.19 0 0 1-2.187-2.193A2.19 2.19 0 0 1 5.25 3.82a2.19 2.19 0 0 1 2.188 2.194zM5.25 7.33a1.315 1.315 0 0 0 0-2.632c-.725 0-1.312.59-1.312 1.316 0 .726.587 1.316 1.312 1.316zm5.25-1.316c0 2.396-3.2 6.661-4.602 8.421a.825.825 0 0 1-1.296 0C3.175 12.675 0 8.41 0 6.014A5.257 5.257 0 0 1 5.25.75c2.898 0 5.25 2.357 5.25 5.264zM5.25 1.627A4.38 4.38 0 0 0 .875 6.014c0 .427.148 1.014.453 1.738.298.71.717 1.48 1.191 2.25.932 1.516 2.036 2.967 2.731 3.841.695-.874 1.8-2.325 2.732-3.84.473-.77.891-1.541 1.19-2.251.305-.724.453-1.31.453-1.738A4.38 4.38 0 0 0 5.25 1.627z"
            />
        </svg>
    );
};

export default React.memo(IconHeaderLocationInactive);
